import React from 'react';

function Map() {
  return (
    <section className="tc-map-style1">
      <div className="container">
        <div className="map-wrapper">
          <iframe
            title="Botanicheska Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2906.868721350016!2d28.003584000000014!3d43.233212000000016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a457001435b1b7%3A0x82247c3c0d8a1500!2sBotanicheska%20302!5e0!3m2!1sen!2sbg!4v1750582974046!5m2!1sen!2sbg"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default Map;
